module.exports = __webpack_public_path__ + "static_pc/img/buy.b603144.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/buy.png
// module id = a+bu
// module chunks = 1